export default __webpack_public_path__ + "static/media/logo1024x1024.f4447393.png";